<!-- <head>
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
</head>
<div class="header">
  <div class="logo header-content"></div>
  <ul class="user-actions header-content">
    <li><a routerLink="/login">Sign in </a></li>
  </ul>
</div>
<div class="nav">
  <ul class="nav-options">
    <li>Our Product</li>
    <li>Plans</li>
    <li>Help</li>
    <li>Contact</li>
  </ul>
</div>
<br /><br /><br /> -->

<!-- <div class="page-container">
  <form #expanForm="ngForm">
    <input hidden name="org_code" [(ngModel)]="extend.org_code" type="text" #org_code="ngModel" class="form-control"
      readonly required />

    <input hidden name="u_type" [(ngModel)]="extend.u_type" type="text" #u_type="ngModel" class="form-control" readonly
      required />

    <input type="text" required [(ngModel)]="extend['first_name']" name="first_name" #first_name="ngModel" class="w-30"
      placeholder="First Name" />

    <input type="text" required [(ngModel)]="extend['last_name']" name="last_name" #last_name="ngModel" class="w-30"
      placeholder="Last Name" />

    <input hidden readonly name="email" [(ngModel)]="extend.email" type="text" #usereid="ngModel" class="form-control"
      readonly required />

    <input hidden readonly name="altemail" [(ngModel)]="extend.altemail" type="text" #altemail="ngModel"
      class="form-control" required />

    <input type="text" required [(ngModel)]="extend.qualification" name="qualification" #qualification="ngModel"
      class="form-control" placeholder="Qualification" />

    <input type="text" required [(ngModel)]="extend.institution" name="institution" #institution="ngModel"
      class="form-control" placeholder="Institutions" />

    <input type="number" required [(ngModel)]="extend.yearq" name="yearq" #year="ngModel" class="form-control"
      placeholder="Number of years experience" />

    <input type="text" required [(ngModel)]="extend.expertise" name="expertise" #expertise="ngModel"
      class="form-control" placeholder="Area of expertise" />

    <button type="button" [disabled]="!expanForm.valid" (click)="addExtend()" class="btn primary-btn "
      routerLink="../admindashboard" name="submit">
      Submit
    </button>
  </form>
</div> -->

<div class="container-fluid wrapper-page">

  <div class="page-head">
    <h4 class="mt-2 mb-2 heading-color">EXTEND MY PROFILE</h4>
  </div>

  <div class="card m-b-30">
    <div class="card-body">
      <div class="row text-center">
        <div class="col-12">
          <h4>
            <span class="mdi mdi-checkbox-marked-outline text-primary"></span>
            By extending your profile, you are agreeing to make your
            account as a Physician’s account.
          </h4>
          <p><em>Note: After confirmation, please log off and log in and update your professional information and Bank information under ‘My Profile’</em></p>
        </div>
        <div class="col-12 mt-4">
          <button type="button" (click)="extendProfile()" class="btn btn-primary rondBrtn"
            name="submit">Confirm</button>
        </div>
      </div>
    </div>
  </div>
  <!-- <form #expanForm="ngForm">
    <div class="card m-b-30">
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-6 col-lg-6">
            <div class="form-group">
              <input hidden name="org_code" [(ngModel)]="extend.org_code" type="text" #org_code="ngModel"
                class="form-control" disabled required />

              <input hidden name="u_type" [(ngModel)]="extend.u_type" type="text" #u_type="ngModel" class="form-control"
                readonly required />

              <input type="text" required [(ngModel)]="extend['first_name']" name="first_name" #first_name="ngModel"
                class="form-control" placeholder="First Name" disabled required />

            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-6">
            <div class="form-group">
              <input type="text" required [(ngModel)]="extend['last_name']" name="last_name" #last_name="ngModel"
                class="form-control" placeholder="Last Name" disabled />
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-6">
            <div class="form-group">
              <input hidden readonly name="email" [(ngModel)]="extend.email" type="text" #usereid="ngModel"
                class="form-control" readonly required />

              <input hidden readonly name="altemail" [(ngModel)]="extend.altemail" type="text" #altemail="ngModel"
                class="form-control" required />

              <input type="text" required [(ngModel)]="extend.qualification" name="qualification"
                #qualification="ngModel" class="form-control" placeholder="Qualification" />
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 col-12">
            <div class="form-group">
              <input type="text" required [(ngModel)]="extend.institution" name="institution" #institution="ngModel"
                class="form-control" placeholder="Institutions" />
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 col-12">
            <div class="form-group">
              <input type="number" required [(ngModel)]="extend.yearq" name="yearq" #year="ngModel" class="form-control"
                placeholder="Number of years experience" />
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 col-12">
            <div class="form-group">
              <input type="text" required [(ngModel)]="extend.expertise" name="expertise" #expertise="ngModel"
                class="form-control" placeholder="Area of expertise" />
            </div>
          </div>
          <div class="offset-md-2 text-center col-lg-8 col-md-8 col-sm-12 col-12">
            <div class="form-group">
              <button type="button" [disabled]="!expanForm.valid" (click)="addExtend()" class="btn btn-primary rondBrtn"
                name="submit">
                Submit
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </form> -->
</div>
